import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const ProtectedRoute = ({ logged_in, children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!logged_in) {
      const timer = setTimeout(() => {
        navigate("/"); // Redirect to home after 5 seconds
      }, 2000);

      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [logged_in, navigate]);

  if (!logged_in) {
    return (
      <div className="landing-page-container">
        <div className="logout-message-container">
          <h2 className="logout-message-title">
            {t("auth.login_message")}
          </h2>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
